import {
    ILateFee, IHoliday, IMarketing, IVendor, IMerchandise, Store,
    IHolidayList, IApiResponse, IFacilityTax, IFacilityMerchPacks, IFacilityMerchandise,
    IFacilityCreditCard, IFacilityFeesAndCharges, IFacilityHoliday, ISaveDeleteResponse,
    IFacilitySaveDiscounts, IDiscountList, IFacilityMarketingQuest, IFacilityMerchandiseInventory,
    IFacilityAdSource,
    IPropertyProtectionCompany,
    IFacilityPropertyProtectionDetails,
    ICodeExist,
    IFacilityGeneralSettings,
    IBillingTypeList,
    IisExist,
    IStoreinfoUnitsList,
    ICreditCardSetting,
    IFacilityGeneralSetting,
    IInternetSettings,
    IGetRentalTrucksList,
    IWalkThrough,
    IFeatures,
    IFacilityHours,
    IFacilityTaxOption,
    IFacilityGateModel,
    IFacilityFeesAndChargesOption,
    IFacilityLateLienUnits,
    IFacilityLateandLienSaveResponse,
    IFacilityLateandLienDetailsSave,
    IFacilityLateandLienDetails,
    IFacilitySections,
    IFacilityUnassignedUnits,
    ICheckSection,
    ISectionDetails,
    ISaveSection,
    ISaveSectionResponse,
    IFacilityTaxUnitModel,
    IFacilityTaxMerchandiseModel,
    IFacilityTaxInsuranceModel,
    IFacilityDiscountUnitsOption,
    IFacilityDiscountMerchandiseOption,
    ISaveModel,
    IFacilityTaxFeesModel,
    IFacilityTaxLateAndLienModel,
    IFacilityPropertyProtectionModel,
    IFacilityInfoACH,
    IEFTSettingListModel,
    INameExists,
    ITimezone,
    ICustomFields,
    IGetOpenStore,
    IChannelList,
    IFacilityintegrationSettings,
    IRegisterStripeTerminal,
    IKeypadZoneModel,
    IResponseModel,
    ISWTDetailsModel


} from './../Shared/interface';
import {
    IFacilityInfo, IDistrict, IState, ITax, ICountry, IFeeCharge, IDiscount, IMerchandiseDiscount,
    ILienStage, IInsurance, IMerchandisePack, IDemography, ICreditCard, IMerchandiseInventory, IMerchandiseInventoryQty
} from '../Shared/interface';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppInsightsService } from './app-insights.service';
import { IUnitTypesDet, IFacilityUnitTypeList, IReportGroupsStoreModel, INewLayoutUnits, ILayoutFloors, IUnitsForLayoutDesign, IFacilityLayouts, IBuildingAreas, ISaveBuildingAreas, IUnitsForLayoutDesignForOperation, IDeviceSetting, IFacilityTerminalDevices } from '../Shared/interface2';
import { AppService } from './app.service';
import { IAdSourceListModel } from '../Shared/models/ProspectModel';

@Injectable({
    providedIn: 'root',
})
export class FacilityService {

    public tempAddedFeesAndCharges = [];
    private baseURL = this.appService.config.apiBaseUrl;
    private internetSettingsurl;
    private gatesystemsurl;
    private walkthroughurl;
    isCustomFieldTabDisplay = false;
    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient,
        private appinsights: AppInsightsService,
        private appService: AppService) { }

    getIsStoreCodeExist(storeCode: string): Observable<ICodeExist> {
        return this.http.get<ICodeExist>(
            `${this.baseURL}/store/GetStoreCodeExist?StroreCode=${storeCode}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const isExist = result.body as ICodeExist;
                    return isExist;
                }
                ),
                catchError(this.handleError)
            );
    }

    getFacilityInfo(storeId: number): Observable<IFacilityInfo> {
        return this.http.get<IFacilityInfo>(
            `${this.baseURL}/store/GetStoreDetail?Id=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const storeDetails = res.body as IFacilityInfo;
                    return storeDetails;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityInfoForOp(storeId: number): Observable<IFacilityInfo> {
        return this.http.get<IFacilityInfo>(
            `${this.baseURL}/store/GetStoreDetailForOp?Id=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const storeDetails = res.body as IFacilityInfo;
                    return storeDetails;
                }),
                catchError(this.handleError)
            );
    }

    insertStore(store: IFacilityInfo): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if (store.Id === 0) {
            url = `${this.baseURL}/store/CreateStorageFacility`;
        } else {
            url = `${this.baseURL}/store/UpdateStorageFacilityDetails`;
        }
        return this.http.post<IApiResponse>(url, store, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    deleteStore(storeId: number) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        // let st = new Store();
        // st.Id = storeId;

        return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/store/DeleteStore?Id=${storeId}`, options);
    }

    getUnits(facilityId: number, taxId: number): Observable<IFacilityTaxUnitModel> {
        return this.http.get<IFacilityTaxUnitModel>(
            `${this.baseURL}/Tax/GetFacilityTaxUnitNTypes?facilityId=${facilityId}&&taxId=${taxId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const TaxUnits = res.body as IFacilityTaxUnitModel;
                    return TaxUnits;
                }),
                catchError(this.handleError)
            );
    }

    getActiveMercahndise(facilityId: number, taxId: number): Observable<IFacilityTaxMerchandiseModel> {
        return this.http.get<IFacilityTaxMerchandiseModel>(
            `${this.baseURL}/Tax/GetFacilityTaxMerchandise?facilityId=${facilityId}&&taxId=${taxId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const Merchandise = res.body as IFacilityTaxMerchandiseModel;
                    return Merchandise;
                }),
                catchError(this.handleError)
            );


    }

    getActiveTaxes(StoreId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/store/GetFacilityTax?StoreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const TaxUnits = res.body as any;
                    return TaxUnits;
                }),
                catchError(this.handleError)
            );
    }

    getActiveTaxesForOp(StoreId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/store/GetFacilityTaxForOp?StoreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const TaxUnits = res.body as any;
                    return TaxUnits;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityTax(tax: IFacilityTax): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityTax`;
        return this.http.post<IApiResponse>(url, tax, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getActiveHolidays(StoreId): Observable<IFacilityHoliday> {
        return this.http.get<IFacilityHoliday>(
            `${this.baseURL}/store/GetFacilityHoliday?StroreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const holidays = res.body as IFacilityHoliday;
                    return holidays;
                }),
                catchError(this.handleError)
            );
    }

    getActiveHolidaysForOp(StoreId): Observable<IFacilityHoliday> {
        return this.http.get<IFacilityHoliday>(
            `${this.baseURL}/store/GetFacilityHolidayForOp?StroreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const holidays = res.body as IFacilityHoliday;
                    return holidays;
                }),
                catchError(this.handleError)
            );
    }

    getActiveInsurance(facilityId: number, taxId): Observable<IFacilityTaxInsuranceModel> {
        return this.http.get<IFacilityTaxInsuranceModel>(
            `${this.baseURL}/Tax/GetFacilityTaxInsurance?facilityId=${facilityId}&&taxId=${taxId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const CompanyId = res.body as unknown as IFacilityTaxInsuranceModel;
                    return CompanyId;
                }),
                catchError(this.handleError)
            );


    }

    getActiveLateandLien(facilityId: number, taxId): Observable<IFacilityTaxLateAndLienModel> {
        return this.http.get<IFacilityTaxLateAndLienModel>(
            `${this.baseURL}/Tax/GetFacilityTaxLateAndLien?facilityId=${facilityId}&&taxId=${taxId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const CompanyId = res.body as unknown as IFacilityTaxLateAndLienModel;
                    return CompanyId;
                }),
                catchError(this.handleError)
            );


    }
    
    getActiveFeesCharge(facilityId: number, taxId): Observable<IFacilityTaxFeesModel> {
        return this.http.get<IFacilityTaxFeesModel>(
            `${this.baseURL}/Tax/GetFacilityTaxFees?facilityId=${facilityId}&&taxId=${taxId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const FeesId = res.body as unknown as IFacilityTaxFeesModel;
                    return FeesId;
                }),
                catchError(this.handleError)
            );


    }

    SaveFacilityHoliday(holiday: IFacilityHoliday): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityHoliday`;
        return this.http.post<ISaveDeleteResponse>(url, holiday, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    // getActivePropertyProtection(StoreId): Observable<IFacilityPropertyProtection> {
    //     return this.http.get<IFacilityPropertyProtection>(
    //         `${this.baseURL}/store/GetFacilityPropertyProtection?StroreId=${StoreId}`,
    //         { observe: 'response' })
    //         .pipe(
    //             map(res => {
    //                 const propPretection = res.body as IFacilityPropertyProtection;
    //                 return propPretection;
    //             }),
    //             catchError(this.handleError)
    //         );
    // }

    // SaveFacilityPropertyProtection(holiday: IFacilityPropertyProtection): Observable<ISaveDeleteResponse> {
    //     let options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    //     const url = `${this.baseURL}/store/SaveFacilityPropertyProtection`;
    //     return this.http.post<ISaveDeleteResponse>(url, holiday, options)
    //         .pipe(
    //             map(res => {
    //                 return res;
    //             }),
    //             catchError(this.handleError)
    //         );
    // }

    getActiveDiscounts(StoreId): Observable<IDiscountList[]> {
        return this.http.get<IDiscountList[]>(
            `${this.baseURL}/store/GetFacilityDiscounts?storeId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const discounts = res.body as IDiscountList[];
                    return discounts;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityDiscount(discounts: IFacilitySaveDiscounts): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityDiscounts`;
        return this.http.post<ISaveDeleteResponse>(url, discounts, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getInsurances(StoreId: number): Observable<IFacilityPropertyProtectionModel> {
        return this.http.get<IFacilityPropertyProtectionModel>(
            `${this.baseURL}/Store/GetFacilityPropertyProtectionForOp?storeId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const insurances = res.body as IFacilityPropertyProtectionModel;
                    return insurances;
                }),
                catchError(this.handleError)
            );
    }

    getDemography(): Observable<IDemography[]> {
        const url = `${this.baseURL}/store/GetDemographies`;
        return this.http.get<IDemography[]>(
            url, { observe: 'response' })
            .pipe(
                map(res => {
                    const demographyies = res.body as IDemography[];
                    return demographyies;
                }),
                catchError(this.handleError)
            );
    }
    getLienStages(): Observable<ILienStage[]> {
        const url = `${this.baseURL}/store/GetLienStages`;
        return this.http.get<ILienStage[]>(
            url, { observe: 'response' })
            .pipe(
                map(res => {
                    const lienStages = res.body as ILienStage[];
                    return lienStages;
                }),
                catchError(this.handleError)
            );
    }

    getCreditCards(storeId: number): Observable<IFacilityCreditCard> {
        return this.http.get<IFacilityCreditCard>(
            `${this.baseURL}/Store/GetFacilityCreditCard?StroreId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const creditCards = res.body as IFacilityCreditCard;
                    return creditCards;
                }),
                catchError(this.handleError)
            );
    }

    getCreditCardsForOp(storeId: number): Observable<IFacilityCreditCard> {
        return this.http.get<IFacilityCreditCard>(
            `${this.baseURL}/Store/GetFacilityCreditCardForOp?StroreId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const creditCards = res.body as IFacilityCreditCard;
                    return creditCards;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityCreditCard(cc: IFacilityCreditCard): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityCreditCard`;
        return this.http.post<IApiResponse>(url, cc, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityMarketingQuest(storeId: number): Observable<IFacilityMarketingQuest> {
        return this.http.get<IFacilityMarketingQuest>(
            `${this.baseURL}/Store/GetFacilityMarketingQuestion?StoreId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const creditCards = res.body as IFacilityMarketingQuest;
                    return creditCards;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityMarketingQuest(mq: IFacilityMarketingQuest): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityMarketingQuestion`;
        return this.http.post<IApiResponse>(url, mq, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }


    // getDistricts(): Observable<IDistrict[]> {
    //     return this.http.get<IDistrict[]>(
    //         `${this.baseURL}/store/GetDistrict`,
    //         { observe: 'response' })
    //         .pipe(
    //             map(res => {
    //                 const districts = res.body as IDistrict[];
    //                 return districts as IDistrict[];
    //             }),
    //             catchError(this.handleError)
    //         );
    // }

    getStates(): Observable<IState[]> {
        return this.http.get<IState[]>(
            `${this.baseURL}/store/GetStates`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const states = res.body as IState[];
                    return states as IState[];

                }),
                catchError(this.handleError)
            );
    }

    getCountries(): Observable<ICountry[]> {
        return this.http.get<ICountry[]>(
            `${this.baseURL}/store/GetCountry`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const countries = res.body as ICountry[];
                    return countries as ICountry[];
                }),
                catchError(this.handleError)
            );
    }

    getActiveFeesAndCharges(StoreId): Observable<IFacilityFeesAndCharges> {
        return this.http.get<IFacilityFeesAndCharges>(
            `${this.baseURL}/Store/GetFacilityFeesandCharges?storeId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const taxes = res.body as IFacilityFeesAndCharges;
                    return taxes;
                }),
                catchError(this.handleError)
            );
    }

    getActiveFeesAndChargesForOp(StoreId): Observable<IFacilityFeesAndCharges> {
        return this.http.get<IFacilityFeesAndCharges>(
            `${this.baseURL}/Store/GetFacilityFeesandChargesForOp?storeId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const taxes = res.body as IFacilityFeesAndCharges;
                    return taxes;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityFeesCharges(fee: IFacilityFeesAndCharges): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityFeesandCharges`;
        return this.http.post<IApiResponse>(url, fee, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    confirm(message?: string): Observable<boolean> {
        const confirmation = window.confirm(message);
        return of(confirmation);
    }

    SaveFacilityMerchPack(merchPacks: IFacilityMerchPacks): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityMerchandisePack`;
        return this.http.post<IApiResponse>(url, merchPacks, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }


    getActiveMerchPacks(StoreId): Observable<IFacilityMerchPacks> {
        return this.http.get<IFacilityMerchPacks>(
            `${this.baseURL}/store/GetFacilityMerchandisePack?StroreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const merchPacks = res.body as IFacilityMerchPacks;
                    return merchPacks;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityMerchandise(merchandise: IFacilityMerchandise): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityMerchandise`;
        return this.http.post<IApiResponse>(url, merchandise, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SaveMerchandiseInventoryQty(invCls: IMerchandiseInventoryQty): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/MerchandiseInventory/SaveMerchandiseInventory`;
        return this.http.post<boolean>(url, invCls, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getActiveMerchandise(StoreId): Observable<IFacilityMerchandise> {
        return this.http.get<IFacilityMerchandise>(
            `${this.baseURL}/store/GetFacilityMerchandise?StroreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const merchandise = res.body as IFacilityMerchandise;
                    return merchandise;
                }),
                catchError(this.handleError)
            );
    }

    getActiveMerchandiseForOp(StoreId): Observable<IFacilityMerchandise> {
        return this.http.get<IFacilityMerchandise>(
            `${this.baseURL}/store/GetFacilityMerchandiseForOp?StroreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const merchandise = res.body as IFacilityMerchandise;
                    return merchandise;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityAdSource(AdSource: IFacilityAdSource): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityAdsource`;
        return this.http.post<IApiResponse>(url, AdSource, options)
            .pipe(
                map(res => {

                    return res;
                }),
                catchError(this.handleError)
            );
    }


    getActiveAdSource(StoreId): Observable<IFacilityAdSource> {
        return this.http.get<IFacilityAdSource>(
            `${this.baseURL}/store/GetFacilityAdsource?StoreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const AdSource = res.body as IFacilityAdSource;
                    return AdSource;
                }),
                catchError(this.handleError)
            );
    }

    getPropertyProtCompany(StoreId): Observable<IPropertyProtectionCompany> {
        return this.http.get<IPropertyProtectionCompany>(
            `${this.baseURL}/store/GetFacilityPropertyProtection?storeId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const propProt = res.body as IPropertyProtectionCompany;
                    return propProt;
                }),
                catchError(this.handleError)
            );
    }
    geActiveProtCompany(strId): Observable<IFacilityPropertyProtectionDetails> {
        return this.http.get<IFacilityPropertyProtectionDetails>(
            `${this.baseURL}/store/GetFacilityPropertyProtectionDetails?storeId=${strId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const propProt = res.body as IFacilityPropertyProtectionDetails;
                    return propProt;
                }),
                catchError(this.handleError)
            );
    }
    SaveFacilityPropertyProtection(propertyProtection: IFacilityPropertyProtectionDetails): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityPropertyProtectionDetails`;
        return this.http.post<IApiResponse>(url, propertyProtection, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityGeneralSettings(StoreId: number): Observable<IFacilityGeneralSetting> {
        return this.http.get<IFacilityGeneralSetting>(
            `${this.baseURL}/store/GetFacilityGeneralSettings?facilityId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const GeneralSettings = res.body as IFacilityGeneralSetting;
                    return GeneralSettings;
                }),
                catchError(this.handleError)
            );
    }


    getActiveBillingTypes(StoreId): Observable<IBillingTypeList> {
        return this.http.get<IBillingTypeList>(
            `${this.baseURL}/store/getActiveBillingTypes?StoreId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const BillingTypes = res.body as IBillingTypeList;
                    return BillingTypes;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityGeneralSettings(GeneralSettings: IFacilityGeneralSetting): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityGeneralSettings`;
        return this.http.post<IApiResponse>(url, GeneralSettings, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    deleteRentalTruck(Id) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/RentalTrucks/DeleteRentalTruck?Id=${Id}`, options);
    }

    saveFacilityCreditCardSettings(CCSettings: ICreditCardSetting): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/store/SaveFacilityCreditCardSettings`;
        return this.http.post<IApiResponse>(url, CCSettings, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    RegisterStripeTerminal(StripeRegister: IRegisterStripeTerminal ): Observable<any>{
          const options = { headers: new HttpHeaders ({'Content-Type': 'application/json'}) };
          let url = `${this.baseURL}/store/RegisterStripeTerminal`;
        return this.http.post<any>(url, StripeRegister, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    
 
    deleteTerminalReader(deleteReaderId, storeId ): Observable<any>{
        const options = { headers: new HttpHeaders ({'Content-Type': 'application/json'}) };
          let url = `${this.baseURL}/store/DeleteTerminalReader?readerId=${deleteReaderId}&facilityId=${storeId}`;
        return this.http.post<any>(url, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
  }

    getFacilityCreditCardSettings(Fid: number, PGid: number): Observable<ICreditCardSetting> {
        return this.http.get<ICreditCardSetting>(
            `${this.baseURL}/Store/GetFacilityCreditCardDetails?facilityId=${Fid}&paymentGatewayId=${PGid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const creditCardDetails = res.body as ICreditCardSetting;
                    return creditCardDetails;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityCreditCardSettingsById(Fid: number): Observable<ICreditCardSetting> {
        return this.http.get<ICreditCardSetting>(
            `${this.baseURL}/Store/GetFacilityCreditCardDetailsById?facilityId=${Fid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const creditCardDetails = res.body as ICreditCardSetting;
                    return creditCardDetails;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityCreditCardSettingsByIdForOp(Fid: number): Observable<ICreditCardSetting> {
        return this.http.get<ICreditCardSetting>(
            `${this.baseURL}/Store/GetFacilityCreditCardDetailsByIdForOp?facilityId=${Fid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const creditCardDetails = res.body as ICreditCardSetting;
                    return creditCardDetails;
                }),
                catchError(this.handleError)
            );
    }

    saveFacilityFeature(feature: IFeatures): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Store/SaveFacilityFeatures`;
        return this.http.post<IApiResponse>(url, feature, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );

    }

    getFacilityFeatures(facid): Observable<IFeatures> {
        return this.http.get<IFeatures>(
            `${this.baseURL}/Store/GetFacilityFeaturesForOp?facilityId=${facid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const feature = res.body as IFeatures;
                    return feature;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityHours(facid): Observable<IFacilityHours> {
        return this.http.get<IFacilityHours>(
            `${this.baseURL}/Store/GetFacilityHours?facilityId=${facid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const hours = res.body as IFacilityHours;
                    return hours;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityHoursForOp(facid): Observable<IFacilityHours> {
        return this.http.get<IFacilityHours>(
            `${this.baseURL}/Store/GetFacilityHoursForOp?facilityId=${facid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const hours = res.body as IFacilityHours;
                    return hours;
                }),
                catchError(this.handleError)
            );
    }

    saveFacilityHours(hours: IFacilityHours): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Store/UpdateFacilityHours`;
        return this.http.post<IApiResponse>(url, hours, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );

    }
    /////////////////////////////// UNIT TYPES SERVICES ///////////////////////////////////////////////////////
    getFacilityUnitLists(storeId): Observable<IStoreinfoUnitsList[]> {
        return this.http.get<IStoreinfoUnitsList[]>(
            `${this.baseURL}/store/GetFacilityUnitsForOp?facilityId=${storeId}`)
            .pipe(
                map(res => {
                    return res as IStoreinfoUnitsList[];
                }),
                catchError(this.handleError)
            );
    }

    GetFacilityUnitsWithNoUnitTypes(storeId): Observable<IStoreinfoUnitsList[]> {
        return this.http.get<IStoreinfoUnitsList[]>(
            `${this.baseURL}/store/GetFacilityUnitsWithNoUnitTypes?facilityId=${storeId}`)
            .pipe(
                map(res => {
                    return res as IStoreinfoUnitsList[];
                }),
                catchError(this.handleError)
            );
    }

    getUnitTypeExists(code): Observable<IisExist> {
        return this.http.get<IisExist>(
            `${this.baseURL}/store/IsUnitTypeExist?unitTypeCode=${code}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const codeExists = res.body as IisExist;
                    return codeExists;
                }),
                catchError(this.handleError)
            );
    }

    getUnitTypeList(strId): Observable<IFacilityUnitTypeList[]> {
        return this.http.get<IFacilityUnitTypeList[]>(
            `${this.baseURL}/store/GetUnitTypeList?facilityId=${strId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IFacilityUnitTypeList[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    getUnitTypeListForOp(strId): Observable<IFacilityUnitTypeList[]> {
        return this.http.get<IFacilityUnitTypeList[]>(
            `${this.baseURL}/store/GetUnitTypeListForOp?facilityId=${strId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IFacilityUnitTypeList[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    getUnitTypeDetails(strId, unitTypeId): Observable<IUnitTypesDet> {
        return this.http.get<IUnitTypesDet>(
            `${this.baseURL}/store/GetUnitType?unitTypeId=${unitTypeId}&facilityId=${strId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IUnitTypesDet;
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    getUnitTypeDetailsForOp(strId, unitTypeId): Observable<IUnitTypesDet> {
        return this.http.get<IUnitTypesDet>(
            `${this.baseURL}/store/GetUnitTypeForOp?unitTypeId=${unitTypeId}&facilityId=${strId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IUnitTypesDet;
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    getNewUnitsByFacility(strId, florid): Observable<INewLayoutUnits[]> {
        return this.http.get<INewLayoutUnits[]>(
            `${this.baseURL}/store/GetNewUnitsByFacility?facilityId=${strId}&floorNumber=${florid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as INewLayoutUnits[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    getUnitsForLayoutDesign(strId, florid): Observable<IUnitsForLayoutDesign[]> {
        return this.http.get<INewLayoutUnits[]>(
            `${this.baseURL}/store/GetUnitsForLayoutDesign?facilityId=${strId}&floorNumber=${florid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IUnitsForLayoutDesign[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    getUnitsForLayoutDesignOperations(strId, florid): Observable<IUnitsForLayoutDesignForOperation[]> {
        return this.http.get<INewLayoutUnits[]>(
            `${this.baseURL}/store/GetUnitsForLayoutDesignOperations?facilityId=${strId}&floorNumber=${florid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IUnitsForLayoutDesignForOperation[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }
    GetUnitTypeListforBatchRR(strId): Observable<IFacilityUnitTypeList[]> {
        return this.http.get<IFacilityUnitTypeList[]>(
            `${this.baseURL}/store/GetUnitTypeListforBatchRR?facilityId=${strId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IFacilityUnitTypeList[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    GetBuildingAreas(strId, florid): Observable<IBuildingAreas[]> {
        return this.http.get<IBuildingAreas[]>(
            `${this.baseURL}/store/GetBuildingAreas?facilityId=${strId}&floorNumber=${florid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IBuildingAreas[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    GetBuildingAreasForOp(strId, florid): Observable<IBuildingAreas[]> {
        return this.http.get<IBuildingAreas[]>(
            `${this.baseURL}/store/GetBuildingAreasForOp?facilityId=${strId}&floorNumber=${florid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as IBuildingAreas[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }

    resetUnitLayout(facilityId, unitId) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<IApiResponse>(`${this.baseURL}/store/ResetUnitLayout?facilityId=${facilityId}&unitId=${unitId}`, options);
    }

    deleteBuildingArea(facilityId, buildingId) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<IApiResponse>(`${this.baseURL}/store/DeleteBuildingArea?facilityId=${facilityId}&buildingId=${buildingId}`, options);
    }

    getFacilityFloor(strId): Observable<ILayoutFloors[]> {
        return this.http.get<ILayoutFloors[]>(
            `${this.baseURL}/store/GetFacilityFloor?facilityId=${strId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const unitType = res.body as ILayoutFloors[];
                    return unitType;
                }),
                catchError(this.handleError)
            );
    }
    SaveFacilityLayout(FacilityLayouts: IFacilityLayouts): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/store/SaveFacilityLayout`;

        return this.http.post<IApiResponse>(url, FacilityLayouts, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SaveBuildingAreas(FacilityLayouts: ISaveBuildingAreas): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/store/SaveBuildingAreas`;

        return this.http.post<IApiResponse>(url, FacilityLayouts, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityUnitTypes(unitType): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if (unitType.UnitTypeId === 0) {
            url = `${this.baseURL}/store/CreateUnitType`;
        } else {
            url = `${this.baseURL}/store/UpdateUnitTypeDetails`;
        }

        return this.http.post<IApiResponse>(url, unitType, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityTaxOptionDetails(facilityId, taxId, taxOpt): Observable<IFacilityTaxOption> {
        return this.http.get<IFacilityTaxOption>(
            `${this.baseURL}/store/GetFacilityTaxOption?facilityId=${facilityId}&taxId=${taxId}&taxOption=${taxOpt}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const taxOption = res.body as IFacilityTaxOption;
                    return taxOption;
                }),
                catchError(this.handleError)
            );
    }
    saveFacilityTaxOption(taxOpt: IFacilityTaxOption): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/UpdateFacilityTaxOption`;
        return this.http.post<IApiResponse>(url, taxOpt, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    getFacilityFeeAndChargeOptionDetails(facilityId, feeId): Observable<IFacilityFeesAndChargesOption> {
        return this.http.get<IFacilityFeesAndChargesOption>(
            `${this.baseURL}/store/GetFacilityFeesAndChargeOption?facilityId=${facilityId}&feesId=${feeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const feeOption = res.body as IFacilityFeesAndChargesOption;
                    return feeOption;
                }),
                catchError(this.handleError)
            );
    }
    SaveFacilityFeesAndChargesOption(feeOpt): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityFeesAndChargesOption`;
        return this.http.post<IApiResponse>(url, feeOpt, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    getFacilityFeeOptionDetails(facilityId, FeeId): Observable<IFacilityFeesAndChargesOption> {
        return this.http.get<IFacilityFeesAndChargesOption>(
            `${this.baseURL}/store/GetFacilityFeesAndChargeOption?facilityId=${facilityId}&feesId=${FeeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const feeOption = res.body as IFacilityFeesAndChargesOption;
                    return feeOption;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityLateAndLienOptionDetails(facilityId, LAndLId): Observable<IFacilityLateLienUnits> {
        return this.http.get<IFacilityLateLienUnits>(
            `${this.baseURL}/store/GetFacilityLateandlienUnitNTypes?facilityId=${facilityId}&lateLienId=${LAndLId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const lateOption = res.body as IFacilityLateLienUnits;
                    return lateOption;
                }),
                catchError(this.handleError)
            );
    }
    SaveFacilityLateAndLienOption(LAndLOpt): Observable<IFacilityLateandLienSaveResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityLateandlienUnitNTypes`;
        return this.http.post<IFacilityLateandLienSaveResponse>(url, LAndLOpt, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    SaveUnittype(unit): Observable<ISaveModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Tax/SaveFacilityTaxUnitNTypes`;
        return this.http.post<ISaveModel>(url, unit, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    SaveMerchansidse(unit): Observable<ISaveModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Tax/SaveFacilityTaxMerchandise`;
        return this.http.post<ISaveModel>(url, unit, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    SaveInsurance(unit): Observable<ISaveModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Tax/SaveFacilityTaxInsurance`;
        return this.http.post<ISaveModel>(url, unit, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    SaveFees(unit): Observable<ISaveModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Tax/SaveFacilityTaxFees`;
        return this.http.post<ISaveModel>(url, unit, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    SaveLateLien(unit): Observable<ISaveModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Tax/SaveFacilityTaxLateandLien`;
        return this.http.post<ISaveModel>(url, unit, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getAllChannelList(): Observable<IChannelList> {
        return this.http.get<IChannelList>(
            `${this.baseURL}/Discounts/GetAllChannels`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as IChannelList;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityLateAndLiensDetails(Late): Observable<IFacilityLateandLienSaveResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/store/SaveFacilityLateandlienDetails`;
        return this.http.post<IFacilityLateandLienSaveResponse>(url, Late, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    getActiveLateAndLien(StoreId): Observable<IFacilityLateandLienDetails> {
        return this.http.get<IFacilityLateandLienDetails>(
            `${this.baseURL}/Store/GetFacilityLateandLienDetails?facilityId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const late = res.body as IFacilityLateandLienDetails;
                    return late;
                }),
                catchError(this.handleError)
            );
    }
    getFacilityDiscountUnitsOptionDetails(facilityId, disId): Observable<IFacilityDiscountUnitsOption> {
        return this.http.get<IFacilityDiscountUnitsOption>(
            `${this.baseURL}/Discounts/GetFacilityDiscountUnitNTypes?facilityId=${facilityId}&discountId=${disId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const discOption = res.body as IFacilityDiscountUnitsOption;
                    return discOption;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityDiscountUnitsOption(DiscOpt: IFacilityDiscountUnitsOption): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Discounts/SaveFacilityDiscountUnitNTypes`;
        return this.http.post<IApiResponse>(url, DiscOpt, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    getFacilityDiscountMerchandiseOptionDetails(disId, facilityId): Observable<IFacilityDiscountMerchandiseOption> {
        return this.http.get<IFacilityDiscountMerchandiseOption>(
            `${this.baseURL}/Discounts/GetFacilityDiscountMerchandise?discountId=${disId}&facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const disMerOpt = res.body as IFacilityDiscountMerchandiseOption;
                    return disMerOpt;
                }),
                catchError(this.handleError)
            );
    }
    SaveFacilityDiscountMerchandiseOption(DisMerOpt: IFacilityDiscountMerchandiseOption): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Discounts/SaveFacilityDiscountMerchandise`;
        return this.http.post<IApiResponse>(url, DisMerOpt, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    saveWalkthroughOrderList(saveWalkthrough: IWalkThrough[], getResponseFlag): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        if (getResponseFlag === false) {
            this.walkthroughurl = `${this.baseURL}/store/CreateWalkthroughOrderList`;
        } else if (getResponseFlag === true) {
            this.walkthroughurl = `${this.baseURL}/store/UpdateWalkthroughOrderList`;
        }

        return this.http.post<IApiResponse>(this.walkthroughurl, saveWalkthrough, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    getWalkthroughOrderList(facId): Observable<IWalkThrough[]> {
        return this.http.get<IWalkThrough[]>(
            `${this.baseURL}/store/GetWalkthroughOrderList?facilityId=${facId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const getWalkThrough = res.body as IWalkThrough[];
                    return getWalkThrough;
                }),
                catchError(this.handleError)
            );
    }
    getIsRentalTrucksDateExist(arrDate, depDate, trkId, facid): Observable<boolean> {
        const dateCheck = new Date(arrDate);
        const dateNew = dateCheck.toUTCString();
        return this.http.get<any>(
            `${this.baseURL}/RentalTrucks/GetTruckExistByDate?arrivalDate=${arrDate}&departureDate=${depDate}&truckId=${trkId}&facilityId=${facid}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    let isExist: boolean;
                    const rentDateExist = result.body as any;
                    if ((typeof rentDateExist === 'undefined') || (rentDateExist === null)) {
                        isExist = false;
                        return rentDateExist;
                    } else {
                        return rentDateExist;
                    }
                }
                ),
                catchError(this.handleError)
            );
    }
    getUnAssignedRentalTrucks(facId): Observable<IGetRentalTrucksList> {
        return this.http.get<IGetRentalTrucksList>(
            `${this.baseURL}/store/GetUnAssignedRentalTrucks?facilityId=${facId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const getUnAssigned = res.body as IGetRentalTrucksList;
                    return getUnAssigned;
                }),
                catchError(this.handleError)
            );
    }
    deleteUnitType(strId: number, unitTypeId, ConnectionId?: string) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/store/DeleteUnitType?unitTypeId=${unitTypeId}&facilityId=${strId}&connectionId=${ConnectionId}`, options);
    }
    getEmailTemplates(ApiUrl, username, password, locId) {
        return this.http.get<any>(
            `${this.baseURL}/store/GetTemplatesBasedOnLocationIdForReviewTracker?APIURL=${ApiUrl}&UserName=${username}&Password=${password}&LocationId=${locId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const emailTemplates = res.body as any;
                    return emailTemplates;
                }),
                catchError(this.handleError)
            );
    }

    GetFacilityInternetSettings(Facilityid) {
        return this.http.get<IInternetSettings>(
            `${this.baseURL}/store/GetFacilityInternetSettings?facilityId=${Facilityid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const internetSettingGet = res.body as IInternetSettings;
                    return internetSettingGet;
                }),
                catchError(this.handleError)
            );
    }

    GetFacilityInternetSettingsForOp(Facilityid) {
        return this.http.get<IInternetSettings>(
            `${this.baseURL}/store/GetFacilityInternetSettingsForOp?facilityId=${Facilityid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const internetSettingGet = res.body as IInternetSettings;
                    return internetSettingGet;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityInternetSettings(internetSettings: IInternetSettings, createFlagNetSetting): Observable<ISaveDeleteResponse> {
        if (createFlagNetSetting === true) {
            this.internetSettingsurl = `${this.baseURL}/store/CreateFacilityInternetSettings`;
        } else if (createFlagNetSetting === false) {
            this.internetSettingsurl = `${this.baseURL}/store/UpdateFacilityInternetSettings`;
        }
        return this.http.post<ISaveDeleteResponse>(this.internetSettingsurl, internetSettings, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GetFacilityGateDetails(Facilityid, GateId) {
        return this.http.get<IFacilityGateModel>(
            `${this.baseURL}/store/GetFacilityGateDetails?facilityId=${Facilityid}&gateId=${GateId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const FacilityGateDetails = res.body as IFacilityGateModel;
                    return FacilityGateDetails;
                }),
                catchError(this.handleError)
            );
    }

    GetFacilityGateDetailsForOp(Facilityid, GateId) {
        return this.http.get<IFacilityGateModel>(
            `${this.baseURL}/store/GetFacilityGateDetailsForOp?facilityId=${Facilityid}&gateId=${GateId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const FacilityGateDetails = res.body as IFacilityGateModel;
                    return FacilityGateDetails;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityGateDetails(facilityGateModel: IFacilityGateModel, IsSave): Observable<ISaveDeleteResponse> {
        if (IsSave === true) {
            this.gatesystemsurl = `${this.baseURL}/store/CreateFacilityGateDetails`;
        } else if (IsSave === false) {
            this.gatesystemsurl = `${this.baseURL}/store/UpdateFacilityGateDetails`;
        }
        return this.http.post<ISaveDeleteResponse>(this.gatesystemsurl, facilityGateModel, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GetFacilityReportGroup(storeId) {
        return this.http.get<IReportGroupsStoreModel>(
            `${this.baseURL}/store/GetFacilityReportGroup?facilityId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const ReportGroupsStore = res.body as IReportGroupsStoreModel;
                    return ReportGroupsStore;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityAminities(storeId) {
        return this.http.get<any>(
            `${this.baseURL}/store/GetFacilityAmenities?facilityId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const aminitiesList = res.body as any;
                    return aminitiesList;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityReportGroup(reportGroupsDetails: IReportGroupsStoreModel): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/store/UpdateFacilityReportGroup`;

        return this.http.post<IApiResponse>(url, reportGroupsDetails, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityAccounts(storeId) {
        return this.http.get<any>(
            `${this.baseURL}/store/GetFacilityAccounts?facilityId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const facilityAccounts = res.body as any;
                    return facilityAccounts;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityAccounts(accountsLists): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/store/SaveFacilityAccounts`;

        return this.http.post<IApiResponse>(url, accountsLists, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    //Sections services starts

    getFacilityTotalSections(StoreId: number): Observable<IFacilitySections> {
        return this.http.get<IFacilitySections>(
            `${this.baseURL}/Store/GetFacilitySection?facilityId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const GeneralSettings = res.body as IFacilitySections;
                    return GeneralSettings;
                }),
                catchError(this.handleError)
            );
    }

    getUnassignedUnits(StoreId: number): Observable<IFacilityUnassignedUnits> {
        return this.http.get<IFacilityUnassignedUnits>(
            `${this.baseURL}/Store/GetUnAssignedSectionUnits?facilityId=${StoreId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const GeneralSettings = res.body as IFacilityUnassignedUnits;
                    return GeneralSettings;
                }),
                catchError(this.handleError)
            );
    }

    checkexistingSection(StoreId: number, sectionName: string): Observable<ICheckSection> {
        return this.http.get<ICheckSection>(
            `${this.baseURL}/Store/CheckFacilitySectionExists?facilityId=${StoreId}&sectionName=${sectionName}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const GeneralSettings = res.body as ICheckSection;
                    return GeneralSettings;
                }),
                catchError(this.handleError)
            );
    }

    getSectionfulldetails(StoreId: number, Sectionid: number): Observable<ISectionDetails> {
        return this.http.get<ISectionDetails>(
            `${this.baseURL}/Store/GetFacilitySectionDetails?facilityId=${StoreId}&sectionId=${Sectionid}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const GeneralSettings = res.body as ISectionDetails;
                    return GeneralSettings;
                }),
                catchError(this.handleError)
            );
    }

    Savesectiondetails(secDetails): Observable<ISaveSectionResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if (secDetails.SectionId > 0) {
            url = `${this.baseURL}/Store/UpdateFacilitySection`;
        } else {
            url = `${this.baseURL}/Store/CreateFacilitySection`;
        }
        return this.http.post<ISaveSectionResponse>(url, secDetails, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    //Sections services ends
    getFacilityInfoACH(facilityId): Observable<IFacilityInfoACH> {
        const url = `${this.baseURL}/store/GetFacilityACHSettings?facilityId=${facilityId}`;
        return this.http.get<IFacilityInfoACH>(
            url, { observe: 'response' })
            .pipe(
                map(res => {
                    const ach = res.body as IFacilityInfoACH;
                    return ach;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityInfoACHForOp(facilityId): Observable<IFacilityInfoACH> {
        const url = `${this.baseURL}/store/GetFacilityACHSettingsForOp?facilityId=${facilityId}`;
        return this.http.get<IFacilityInfoACH>(
            url, { observe: 'response' })
            .pipe(
                map(res => {
                    const ach = res.body as IFacilityInfoACH;
                    return ach;
                }),
                catchError(this.handleError)
            );
    }

    getFacilityInfoEFT(facilityId): Observable<IEFTSettingListModel> {
        const url = `${this.baseURL}/EFTSetting/GetFacilityEFTSettings?facilityId=${facilityId}`;
        return this.http.get<IEFTSettingListModel>(
            url, { observe: 'response' })
            .pipe(
                map(res => {
                    const eft = res.body as IEFTSettingListModel;
                    return eft;
                }),
                catchError(this.handleError)
            );
    }
    SaveFacilityInfoACH(achLists): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/store/UpdateFacilityACHSettings`;

        return this.http.post<IApiResponse>(url, achLists, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityDefaultLettersAndNotices(facilityDefaultLetterModel, facilityId, isCreate): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/UpdateFacilityDefaultLettersAndNotices?facilityId=${facilityId}&isCreate=${isCreate}`;

        return this.http.post<ISaveDeleteResponse>(url, facilityDefaultLetterModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SaveFacilityDefaultLettersAndNoticesForOp(facilityDefaultLetterModel, facilityId, isCreate): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/UpdateFacilityDefaultLettersAndNoticesForOp?facilityId=${facilityId}&isCreate=${isCreate}`;

        return this.http.post<ISaveDeleteResponse>(url, facilityDefaultLetterModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getTerminalDevices(storeId: number): Observable<IDeviceSetting[]> {
        return this.http.get<IDeviceSetting[]>(
            `${this.baseURL}/CreditCard/GetTerminalDevices?facilityId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const devices = res.body as IDeviceSetting[];
                    return devices;
                }),
                catchError(this.handleError)
            );
    }

    getTerminalDevicesForOp(storeId: number): Observable<IDeviceSetting[]> {
        return this.http.get<IDeviceSetting[]>(
            `${this.baseURL}/CreditCard/GetTerminalDevicesForOp?facilityId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const devices = res.body as IDeviceSetting[];
                    return devices;
                }),
                catchError(this.handleError)
            );
    }

    SaveTerminalDeviceDetails(deviceDetails: IFacilityTerminalDevices): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/CreditCard/SaveTerminalDevices`;
        return this.http.post<IApiResponse>(url, deviceDetails, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    CheckIfDeviceNameExists(deviceName: string, facilityId): Observable<INameExists> {
        return this.http.get<INameExists>(
            `${this.baseURL}/CreditCard/IFNameExist?deviceId=${deviceName}&facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const NameExist = result.body as INameExists;
                    return NameExist;
                }
                ),
                catchError(this.handleError)
            );
    }



    getTimezone(): Observable<ITimezone[]> {
        return this.http.get<ITimezone[]>(
            `${this.baseURL}/store/GetTimezone`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const states = res.body as ITimezone[];
                    return states as ITimezone[];

                }),
                catchError(this.handleError)
            );
    }
    CheckFacilityGateSettingExist(facilityId: number): Observable<IResponseModel> {
            return this.http.get<IResponseModel>(
                `${this.baseURL}/Store/CheckFacilityGateSettingExist?facilityId=${facilityId}`,
                { observe: 'response' })
                .pipe(
                    map(result => {
                        const gateSystemExists = result.body as IResponseModel;
                        return gateSystemExists;
                    }
                    ),
                    catchError(this.handleError)
                );
        }
    GetFacilityKeyPadZone(facilityId, gateId): Observable<IKeypadZoneModel[]> {
            return this.http.get<IKeypadZoneModel[]>(
                `${this.baseURL}/Store/GetFacilityKeyPadZone?facilityId=${facilityId}&gateId=${gateId}`,
                { observe: 'response' }).pipe(
                    map(res => {
                        return res.body as IKeypadZoneModel[];
                    }),
                    catchError(this.handleError)
                );
    
    }

    getFacilityCustomFields(facilityId): Observable<ICustomFields[]> {
        return this.http.get<ICustomFields[]>(
            `${this.baseURL}/store/GetFacilityCustomFields?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const states = res.body as ICustomFields[];
                    return states as ICustomFields[];

                }),
                catchError(this.handleError)
            );
    }

    getStoreCustomFields(): Observable<ICustomFields[]> {
        return this.http.get<ICustomFields[]>(
            `${this.baseURL}/store/GetStoreCustomFields`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const states = res.body as ICustomFields[];
                    return states as ICustomFields[];

                }),
                catchError(this.handleError)
            );
    }

    getStoreCustomFieldsForOp(): Observable<ICustomFields[]> {
        return this.http.get<ICustomFields[]>(
            `${this.baseURL}/store/GetStoreCustomFieldsForOp`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const states = res.body as ICustomFields[];
                    return states as ICustomFields[];

                }),
                catchError(this.handleError)
            );
    }

    saveFacilityCustomFields(facilityId, customFieldsList): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Store/SaveFacilityCustomFields?facilityId=${facilityId}`;
        return this.http.post<IApiResponse>(url, customFieldsList, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }


    GetFacilityCashRegisterDenominations(facilityId: number): Observable<IGetOpenStore> {
        return this.http.get<IGetOpenStore>(
            `${this.baseURL}/OpenCloseStore/GetFacilityCashRegisterDenominations?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const info = res.body as IGetOpenStore;
                    return info;
                }),
                catchError(this.handleError)
            );
    }

    SaveIntegrationSystem(details: any): Observable<any[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Store/SaveIntegrationSettings`;
        return this.http.post<any[]>(url, details, options)
            .pipe(
                map(res => {

                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GetIntegrationSettings(facilityId: number): Observable<IFacilityintegrationSettings[]> {
        return this.http.get<any>(
            `${this.baseURL}/Store/GetIntegrationSettings?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const info = res.body as IFacilityintegrationSettings[];
                    return info;
                }),
                catchError(this.handleError)
            );
    }
        getAmenityExists(amenity: string, facilityId: number): Observable<INameExists> {
            return this.http.get<INameExists>(
              `${this.baseURL}/Store/GetAmenityExists?amenity=${amenity}&amenityId=${facilityId}`,
              { observe: 'response' })
              .pipe(
                  map(result => {
                      const isExist = result.body as INameExists;
                      return isExist;
                  }
                  ),
                  catchError(this.handleError)
              );
          }
          
    DeleteIntegrationSettings(integrationSettingId: any, facilityId) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/Store/DeleteIntegrationSettings?id=${integrationSettingId}&facilityId=${facilityId}`;
        return this.http.delete<any>(url, options)
           .pipe(
              map(res => {
                 return res;
              }),
           );
     }

     getFacilityofPaymentGateway(paymentGateway: number): Observable<any[]> {
        const url = `${this.baseURL}/Store/GetFacilityofPaymentGateway?paymentGateway=${paymentGateway}`;
        return this.http.get<any[]>(url)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    
    SavePricingCategoryDetails(obj): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/PricingCategory/SavePricingCategoryDetails`;
        return this.http.post<any>(url,obj, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    GetPricingCategoryDetails(facilityId): Observable<any> {
        return this.http.get<any>(`${this.baseURL}/PricingCategory/GetPricingCategoryDetails?facilityId=${facilityId}`)
          .pipe(
            map(res => {
              return res;
            }),
            catchError(this.handleError)
          );
    }
   
    GetFacilityDateTime(facilityId): Observable<any> {
        return this.http.get<any>(`${this.baseURL}/Store/GetFacilityDateTime?facilityId=${facilityId}`)
          .pipe(
            map(res => {
              return res;
            }),
            catchError(this.handleError)
          );
    }
    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

    private handleHttpPostError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error);
            return of(result as T);
        };
    }

    getSWTDetails(facilityId: number): Observable<ISWTDetailsModel> {
        return this.http.get<ISWTDetailsModel>(
            `${this.baseURL}/store/GetSWTDetails?facilityId=${facilityId}`
        )
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SaveSWTDetails(saveSWTDetails: ISWTDetailsModel): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<IApiResponse>(
            `${this.baseURL}/store/SaveSWTDetails`, saveSWTDetails, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
  }

  getUnitTypeListForBulkAttribute(strId): Observable<IFacilityUnitTypeList[]> {
    return this.http.get<IFacilityUnitTypeList[]>(
      `${this.baseURL}/store/GetUnitTypeListForBulkAttribute?facilityId=${strId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const unitType = res.body as IFacilityUnitTypeList[];
          return unitType;
        }),
        catchError(this.handleError)
      );
  }
}
